const SheetJSFT = [
	"xlsx"
].map(function(x) { return "." + x; }).join(",");